export const BATCH_SIZE = 20
export const MAX_SEARCH_COUNT = 50
export const PERFORMANCE_THRESHOLD = 100
export const LARGE_IMPORT_THRESHOLD = 200

export const PRODUCT_SEGMENT_TYPES = [
  'PRODUCT_COUNT',
  'PCM_PURCHASED_PRODUCT', 
  'APP_ADD_TO_CART_PRODUCT',
  'WEB_ADD_TO_CART_PRODUCT',
  'appAddToCart',
  'webAddToCart',
]

export const TREE_DIMENSIONS = [
  // Add tree dimension codes here if needed
]

export const LOADING_SPINNER_STYLES = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @keyframes progressAnimation {
    0% { margin-left: -30%; }
    100% { margin-left: 100%; }
  }
`

export const DEBOUNCE_DELAY = 500
export const BATCH_DELAY = 100
export const ITEMS_PER_PAGE = 50 